import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { globalObject, isBrowser } from '@skbkontur/global-object';
import { isInstanceOf } from "../../../lib/isInstanceOf";
import * as LayoutEvents from "../../../lib/LayoutEvents";
import { RenderContainer } from "../../RenderContainer";
import { ZIndex } from "../../ZIndex";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { cx } from "../../../lib/theming/Emotion";
import { isIE11 } from "../../../lib/client";
import { getDOMRect } from "../../../lib/dom/getDOMRect";
import { styles } from "../DropdownContainer.styles";
import { getManualPosition, getTopAlignment } from "../getManualPosition";
export var DropdownContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(DropdownContainer, _React$PureComponent);

  function DropdownContainer(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.getProps = createPropsGetter(DropdownContainer.defaultProps);

    _this.ZIndexRef = function (element) {
      _this.dom = element;
    };

    _this.position = function () {
      var target = _this.props.getParent();

      var dom = _this.dom;

      if (target && isInstanceOf(target, globalObject.Element) && dom && isBrowser(globalObject)) {
        var targetRect = getDOMRect(target);
        var _globalObject$documen = globalObject.document,
            body = _globalObject$documen.body,
            docEl = _globalObject$documen.documentElement;

        if (!docEl) {
          throw Error('There is no "documentElement" in "document"');
        }

        var scrollX = globalObject.pageXOffset || docEl.scrollLeft || 0;
        var scrollY = globalObject.pageYOffset || docEl.scrollTop || 0;
        var left = null;
        var right = null;

        if (_this.getProps().align === 'right') {
          var docWidth = docEl.offsetWidth || 0;
          right = docWidth - (targetRect.right + scrollX) + _this.getProps().offsetX;
        } else {
          left = targetRect.left + scrollX + _this.getProps().offsetX;
        }

        var offsetY = _this.getProps().offsetY || 0;
        var bottom = null;
        var top = targetRect.bottom + scrollY + offsetY;
        var distanceToBottom = docEl.clientHeight - targetRect.bottom;

        var dropdownHeight = _this.getHeight();

        var clientHeight = _this.state.isDocumentElementRoot ? docEl.clientHeight : body.scrollHeight;

        if (distanceToBottom < dropdownHeight && targetRect.top > dropdownHeight) {
          top = null;
          bottom = getTopAlignment({
            clientHeight: clientHeight,
            offsetY: offsetY,
            scrollY: scrollY,
            target: target
          });
        }

        var position = _extends({
          top: top,
          left: left,
          right: right,
          bottom: bottom
        }, getManualPosition({
          menuPos: _this.props.menuPos,
          target: target,
          offsetY: offsetY,
          clientHeight: clientHeight,
          scrollY: scrollY
        }));

        _this.setState({
          minWidth: _this.getMinWidth(),
          position: _this.getProps().disablePortal ? _this.convertToRelativePosition(position) : position
        });
      }
    };

    _this.getHeight = function () {
      if (!isInstanceOf(_this.dom, globalObject.Element)) {
        return 0;
      }

      var child = _this.dom.children.item(0);

      return getDOMRect(child).height;
    };

    _this.getMinWidth = function () {
      var target = _this.props.getParent();

      return getDOMRect(target).width;
    };

    _this.convertToRelativePosition = function (position) {
      var target = _this.props.getParent();

      var offsetX = _this.getProps().offsetX || 0;
      var offsetY = _this.getProps().offsetY || 0;
      var top = position.top,
          bottom = position.bottom,
          left = position.left,
          right = position.right;

      if (isInstanceOf(target, globalObject.Element)) {
        var targetHeight = getDOMRect(target).height;
        return {
          top: top !== null ? targetHeight + offsetY : null,
          bottom: bottom !== null ? targetHeight + offsetY : null,
          left: left !== null ? offsetX : null,
          right: right !== null ? offsetX : null
        };
      }

      return {
        top: offsetY,
        bottom: null,
        left: offsetX,
        right: null
      };
    };

    _this.state = {
      position: null,
      minWidth: 0,
      isDocumentElementRoot: getIsDocumentElementRoot()
    };
    return _this;
  }

  var _proto = DropdownContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.position();
    this.layoutSub = LayoutEvents.addListener(this.position);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.layoutSub) {
      this.layoutSub.remove();
    }
  };

  _proto.render = function render() {
    var _cx;

    var style = {
      position: 'absolute',
      top: '0'
    };

    if (this.state.position) {
      var _this$state$position = this.state.position,
          top = _this$state$position.top,
          bottom = _this$state$position.bottom,
          left = _this$state$position.left,
          right = _this$state$position.right;
      style = _extends({}, style, {
        top: top !== null ? top : undefined,
        bottom: bottom !== null ? bottom : undefined,
        left: left !== null ? left : undefined,
        right: right !== null ? right : undefined,
        minWidth: this.state.minWidth,
        maxWidth: this.props.hasFixedWidth ? this.state.minWidth : undefined
      });
    }

    var content = /*#__PURE__*/React.createElement(ZIndex, {
      "data-tid": this.props['data-tid'],
      id: this.props.id,
      priority: 'DropdownContainer',
      wrapperRef: this.ZIndexRef,
      style: style,
      className: cx((_cx = {}, _cx[styles.alignRight()] = this.getProps().align === 'right' && !isIE11, _cx))
    }, this.props.children);
    return this.props.disablePortal ? content : /*#__PURE__*/React.createElement(RenderContainer, null, content);
  };

  return DropdownContainer;
}(React.PureComponent);
DropdownContainer.__KONTUR_REACT_UI__ = 'DropdownContainer';
DropdownContainer.displayName = 'DropdownContainer';
DropdownContainer.defaultProps = {
  align: 'left',
  disablePortal: false,
  offsetX: 0,
  offsetY: -1
};

var getIsDocumentElementRoot = function getIsDocumentElementRoot() {
  if (!isBrowser(globalObject)) {
    return false;
  }

  var _globalObject$documen2 = globalObject.document,
      body = _globalObject$documen2.body,
      documentElement = _globalObject$documen2.documentElement;
  var htmlPosition = globalObject.getComputedStyle(documentElement).position;
  var bodyPosition = globalObject.getComputedStyle(body).position;
  var hasLimitedHeightRoot = body.scrollHeight > body.clientHeight;
  var hasStaticRoot = htmlPosition === 'static' && bodyPosition === 'static';
  return hasLimitedHeightRoot || hasStaticRoot;
};